
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"100","viewBox":"0 0 110 110"}, attrs),
              ...rest,
            },
            children.concat([_c('svg',{attrs:{"height":"93.614","viewBox":"0 0 117.527 93.614","width":"105.527","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M101.189 46.125c0-.208.019-.417.019-.644a16.675 16.675 0 00-16.675-16.675h-28.8v16.675a7.58 7.58 0 01-15.159 0V22.743h.076a13.649 13.649 0 0113.566-12.127h21.222a14.306 14.306 0 011.573.095l7.6-7.6a10.6 10.6 0 0115.007 0l14.8 14.8a10.6 10.6 0 010 15.007l-13.21 13.207zM34.51 22.743v22.738a13.643 13.643 0 1027.286 0V34.87h22.737a10.616 10.616 0 012.046 21.033 9.087 9.087 0 01-6.594 15.348h-.512a8.935 8.935 0 01.512 3.032 9.1 9.1 0 01-9.1 9.1H40.573a4.615 4.615 0 01-.512-.019l-7.144 7.144a10.6 10.6 0 01-15.007 0L3.112 75.725a10.6 10.6 0 010-15.007l13.207-13.21v-6.575a18.2 18.2 0 0118.191-18.19z","fill":"#63cdf5"}})])])
          )
        }
      }
    